(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-parts-gallery]').forEach((gallery) => {
      if (gallery.dataset.partsReady) return;
      const main = gallery.querySelector('.mp-parts__image');
      if (!main) return;
      gallery.dataset.partsReady = 'true';
      gallery.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-parts-thumbnail]');
        if (!thumbnail || !gallery.contains(thumbnail) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!thumbnail.dataset.imageSrc) return;
        event.preventDefault();
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumbnail.dataset.imageSrc;
        main.alt = thumbnail.dataset.imageAlt || '';
        main.width = Number(thumbnail.dataset.imageWidth);
        main.height = Number(thumbnail.dataset.imageHeight);
        gallery.querySelectorAll('[data-parts-thumbnail]').forEach((item) => item.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
        const status = gallery.querySelector('[data-parts-image-status]');
        if (status) status.textContent = thumbnail.getAttribute('aria-label');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
